import React from "react";

export const SharerItems = ({
  includeMail = true,
  link,
  title = "Jaarkalender",
  onClick
}) => {
  const shareLinkWithModal = (e, url) => {
    onClick();
    e.preventDefault();
    window.open(url, "share-dialog", "width=626,height=436");
    return false;
  };

  const _link = link ? link : window.location.href;

  return (
    <div className="sharer__items">
      <button
        onClick={e =>
          shareLinkWithModal(
            e,
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              _link
            )}`
          )
        }
        target="_blank"
        className="btn btn--share facebook"
      ></button>
      <button
        onClick={e =>
          shareLinkWithModal(
            e,
            `https://twitter.com/intent/tweet?url=${encodeURIComponent(
              _link
            )}&text=`
          )
        }
        className="btn btn--share twitter"
      ></button>
      <button
        onClick={e =>
          shareLinkWithModal(
            e,
            `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
              _link
            )}&title=${title}`
          )
        }
        className="btn btn--share linkedin"
      ></button>
      {includeMail && (
        <a
          href={`mailto:?subject=${title}&body=${encodeURIComponent(`
          Bekijk de jaarkalender op: ${_link}
        `)}`}
          className="btn btn--share email"
        ></a>
      )}
    </div>
  );
};
